import { FormControl, InputLabel, OutlinedInput, InputAdornment } from "@mui/material";
import { Avatar } from "../../fieldsViews/fields/Avatar";
import { UseFormReturn } from "react-hook-form";
import { useEffect } from "react";
import { useRecords } from "../../../api/useRecords";
import { STALE_TIME_24H } from "../../../utils/constants";
import { useUser } from "../../../api/useAuth";
import { userM2mFields, userM2oFields } from "./dynamicUserUtils";

type DynamicUserValueFieldProps = {
	entityForm: UseFormReturn;
	index: number;
    field: string
};

export const DynamicUserValueField = ({ entityForm, index, field }: DynamicUserValueFieldProps) => {
    const {data: techniciansData, status: techniciansStatus} = useRecords("technicians", "id,user_id.id,user_id.avatar,user_id.first_name,user_id.last_name", {extraOptions:{filter: {user_id: "$CURRENT_USER"}}, fetch: { fetchOnFocus: false }, staleTime: STALE_TIME_24H})
    const {data: currentUser, status: currentUserStatus} = useUser();

    const avatarId = techniciansData?.items[0]?.user_id?.avatar

    useEffect(() => {
        const technician = {...techniciansData?.items[0], isDynamic: true}
        if (techniciansStatus === "success" && technician?.id) {
            if (field === "theurapists_involved_in_treamtent") {
                const data = {
                    id: technician.id,
                    label: technician.user_id?.first_name + " " + technician.user_id?.last_name,
                    item: technician,
                    isDynamic: true
                }

            entityForm.setValue(`filters.${index}.value`, [ data]);
            }
            if (field === "client_owner") {
                entityForm.setValue(`filters.${index}.value`, technician);
            }
        }
        if (currentUserStatus === "success" && currentUser?.id) {
            const data = {
                id: currentUser.id,
                label: currentUser.first_name + " " + currentUser.last_name,
                item: currentUser,
                isDynamic: true
            }

            if (userM2mFields.includes(field)) {
                entityForm.setValue(`filters.${index}.value`, [data]);
            }
            if (userM2oFields.includes(field)) {
                entityForm.setValue(`filters.${index}.value`, data);
            }
         
            
        }
    }, [techniciansData, techniciansStatus, currentUser, currentUserStatus]);

	return (
		<FormControl fullWidth>
			<InputLabel>Utilizador</InputLabel>
			<OutlinedInput
				value="Próprio"
				label="Utilizador"
				disabled
				sx={{ minHeight: "57px" }}
				startAdornment={
					avatarId && (
						<InputAdornment position="start">
							<Avatar value={avatarId} styles={{ width: 20, height: 20 }} />
						</InputAdornment>
					)
				}
			/>
		</FormControl>
	);
};
